<template>
  <dara-invisible>
    <dara-table-label
      :label="label"
      :show-range-date="showRangeDate"
      :type="type"
      @fetch="fetch({ start: $event[0], end: $event[1] })"
      @download="downloadCSV" />

    <dara-row class="mb--lg d-flex justify-content-center justify-content--space-between">
      <dara-col class="bg-color--info-light gray-card table-border">
        <dara-table-header v-if="data.length > 0" :columns="columns" @orderBy="fetch($event)" />
        <div v-if="data.length > 0">
          <dara-invisible v-for="item in data.slice(0, pagination.limit)" :key="item.id">
            <hr class="line">
            <dara-table-item v-if="item" ref="index" class="mt--lg" :data="item" :type="type" />
          </dara-invisible>
          <hr v-if="pagination.total > pagination.limit" class="line">
          <dara-pagination
            class="mt--xl"
            :background="true"
            :small="true"
            :page.sync="pagination.page"
            :total="pagination.total"
            :page-size="pagination.limit"
            @current-change="fetch()" />
        </div>
        <div v-else>
          <dara-item-table-layout>
            <template #empty class="mt--md">
              <dara-header size="sm" class="mt--lg color--info">
                {{ type == 'article' ? $t('empty-articles-table') : '' }}
                {{ type == 'question' ? $t('empty-questions-table') : '' }}
                {{ type == 'track' ? $t('empty-tracks-table') : '' }}
              </dara-header>
            </template>
          </dara-item-table-layout>
        </div>
      </dara-col>
    </dara-row>
  </dara-invisible>
</template>

<script>
import DaraTableLabel from '@/components/table/TableLabel.vue';
import DaraTableHeader from '@/components/table/TableHeader.vue';
import DaraTableItem from '@/components/table/TableItem.vue';
import DaraItemTableLayout from '@/layouts/ItemTableLayout.vue';

export default {
  name: 'DaraTable',
  components: {
    DaraTableLabel,
    DaraTableHeader,
    DaraTableItem,
    DaraItemTableLayout,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
    },
    showRangeDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      by: null,
      order: null,
      start: null,
      end: null,
      tablePagination: this.pagination,
    };
  },
  methods: {
    fetch(params = { by: null, order: null, start: null, end: null }) {
      this.by = params.by == null ? this.by : params.by;
      this.order = params.order == null ? this.order : params.order;
      this.start = params.start == null ? this.start : params.start;
      this.end = params.end == null ? this.end : params.end;
      const payload = {
        startDate: this.start,
        endDate: this.end,
        ...this.pagination,
      };
      // THIS NEEDS TO BE OUTSIDE THE PAYLOAD {...} (IDK WHY)
      payload.by = this.by;
      payload.order = this.order;
      this.$emit('fetch', payload);
    },
    downloadCSV() {
      const payload = {
        by: this.by,
        order: this.order,
        startDate: this.start,
        endDate: this.end,
        page: 1,
        limit: 9999999999,
      };
      this.$emit('download', payload);
    },
  },
};
</script>

<style scoped>
  .gray-card {
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-top: 20px solid transparent;
    border-bottom : 20px solid transparent;
    border-radius: 5px;
    margin: 0rem 0.6rem 0rem 0.6rem;
    background-color: #f4f4f5 !important;
  }
  .line {
    color: rgb(158, 158, 158) !important;
    width: 100%;
  }
  .table-border {
    border-right: 20px solid transparent !important;
    border-left: 20px solid transparent !important;
    border-top: 30px solid transparent !important;
    border-bottom : 30px solid transparent !important;
  }
</style>
